import Typography from "@mui/material/Typography";

export function Warning(props: any) {
  if (props.enteredSentenceImposed > props.maxSentenceImposed) {
    return (
      <Typography variant="subtitle1" color="#B30000">
        Warning! This is ABOVE the number of years expected for this felony
        class.
      </Typography>
    );
  }
  return null;
}
